import 'css-chunksrc/client/pages/projectPage/documentsPage/reportsPage/header/styles.scss';export default {
  "report": "_report_s4t0j_1",
  "header": "_header_s4t0j_7",
  "headerItem": "_headerItem_s4t0j_14",
  "title": "_title_s4t0j_33"
};